import type { ReactElement } from "react";
import { useMemo } from "react";

import { ConditionCard } from "app/pages/sales-intelligence/common-components/filters-panel";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ISiteTagsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";

interface IInclusionSiteTagsChipProps {
    item: ISiteTagsDto;
    hideActionButton?: boolean;
    onEdit: (item: ISiteTagsDto) => void;
    onDelete: (item: ISiteTagsDto) => void;
}

const InclusionSiteTagsChip = ({
    item,
    hideActionButton = false,
    onEdit,
    onDelete,
}: IInclusionSiteTagsChipProps): ReactElement => {
    const values = useMemo((): string[] => [...item.values], [item]);

    return (
        <ConditionCard
            inclusionLabel={<I18n translatable={{ key: `si.common.inclusions.${item.inclusion}` }} />}
            values={values}
            hideActions={hideActionButton}
            onEdit={() => onEdit(item)}
            onDelete={() => onDelete(item)}
            dataAutomation="site-tags-inclusion-chip"
        />
    );
};

export default InclusionSiteTagsChip;
